"use client";

// Universal auth-landing catcher (mounted in the root layout, runs on every
// page incl. the homepage). When an auth credential lands on the WRONG page —
// a PKCE ?code= or an implicit #access_token that fell back to the Site URL
// because the redirect_to origin didn't match Supabase's allow list, or an old
// email pointing at the server callback — this grabs it and forwards it, query
// + hash intact, to the right CLIENT page that knows how to absorb it:
//
//   password recovery  → /reset-password   (set a new password)
//   everything else    → /auth/land        (establish session, go to next)
//
// This is the safety net that makes auth work regardless of which origin /
// allow-list quirk produced the landing.

import { useEffect } from "react";

export default function AuthHashCatch() {
  useEffect(() => {
    const { pathname, search, hash } = window.location;

    // the dedicated auth pages handle their own params — don't fight them
    if (pathname === "/reset-password" || pathname.startsWith("/auth/")) return;

    const hasCode = new URLSearchParams(search).has("code");
    const hasAuthHash =
      hash.includes("access_token=") || (hash.includes("error=") && hash.includes("type="));
    if (!hasCode && !hasAuthHash) return;

    // recovery: the hash says so, or forgot-password set a one-shot flag
    // (PKCE is same-browser, so the flag is reliably here when it matters).
    let recovery = hash.includes("type=recovery");
    try {
      if (localStorage.getItem("innernet-pwreset") === "1") {
        recovery = true;
        localStorage.removeItem("innernet-pwreset");
      }
    } catch {
      /* private mode */
    }

    const dest = recovery ? "/reset-password" : "/auth/land";
    window.location.replace(`${dest}${search}${hash}`);
  }, []);

  return null;
}
